import React from "react";
import { FormLabel, Paper, Box, Radio, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";
import { componentTokens } from "../../../theme/tokens/components.js";
import { colorsFoundation, borderRadius } from "../../../theme/index.js";

DetailedRadioGroup.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function DetailedRadioGroup(props) {
  const { item, value = "", onChange, disabled = false } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: componentTokens.formSection.backgroundColor,
        borderRadius: componentTokens.formSection.borderRadius,
        height: "100%",
        width: "100%",
        p: componentTokens.formSection.padding,
        margin: "0px",
      }}
    >
      <FormLabel
        filled={true}
        sx={{ mb: componentTokens.formSection.padding, display: "block" }}
      >
        {item.label}
      </FormLabel>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        {item.options.map((option) => (
          <Box
            key={option.key}
            sx={{
              flex: "1 0 calc(" + 100 / item.options.length + "% - 16px)",
              minWidth: "200px",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border:
                  value === option.key
                    ? `2px solid ${colorsFoundation.key.gold[600]}`
                    : "2px solid transparent",
                backgroundColor: colorsFoundation.neutral.white,
                borderRadius: borderRadius.sm,
                height: "100%",
                width: "100%",
                pl: "20px",
                pr: "20px",
                pt: "15px",
                pb: "15px",
                mt: "10px",
                ...(!disabled && {
                  ":hover": {
                    backgroundColor: colorsFoundation.key.gold[50],
                    border: `2px solid ${colorsFoundation.key.gold[600]}`,
                    cursor: "pointer",
                  },
                }),
              }}
              onClick={(e) =>
                !disabled &&
                onChange(convertToDefEventPara(item.name, option.key))
              }
            >
              <Box sx={{ textAlign: "center", height: "100%" }}>
                <Typography variant="title" sx={{ pb: "10px" }} component="h1">
                  {option.label}
                </Typography>
                <Typography
                  variant="body"
                  component="h1"
                  sx={{ textAlign: "center" }}
                >
                  {option.detail}
                </Typography>
              </Box>
              <Radio
                disabled={disabled}
                key={option.key}
                checked={value === option.key}
                onChange={onChange}
                value={option.key}
                name={item.name}
              />
            </Paper>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
